import React from 'react';

export function companyQualifyTip() {
    return <ul className="icon-text">
        <li>请上传最新年检的企业营业执照/个体工商户执照/组织机构代码证或税务证（三合一）</li>
        <li>企业营业执照或个体工商户执照需含年检部分</li>
        <li>图片仅支持jpg或png格式，大小不超过10M</li>
    </ul>;
}
export function socialTip() {
    return <ul className="icon-text">
        <li>请上传统一社会信用代码证</li>
        <li>图片仅支持jpg或png格式，大小不超过10M</li>
    </ul>;
}
export function governmentCertTip() {
    return <ul className="icon-text">
        <li>请提供号码开户证明/号码缴费发票/号码归属证明（三选一即可）</li>
        <li>图片仅支持jpg或png格式，大小不超过10M</li>
    </ul>;
}

export function certTip() {
    return <ul className="icon-text">
        <li>以下证明材料三选一：</li>
        <li>开户证明（图片）、号码缴费发票（图片）、号码归属证明（视频）。</li>
        <li>运营商证明中需体现申诉号码。</li>
        <li>号码归属证明需运营商或运营商代理盖章。视频需要按示例要求才能通过审核。</li>
        <li>图片仅支持jpg或png格式，大小不超过10M。</li>
        <li>视频大小不超过20M。</li>
        <li>根据相关法律规定，伪造印章、营业执照属于违法行为，百度保留依法追究其法律责任的权利。</li>
    </ul>;
}

export function feedbackTip() {
    return <ul className="icon-text">
        <li>图片仅支持jpg或png格式，大小不超过10M</li>
    </ul>;
}
